import { useTheme } from '@sds-system/system';
import { useMediaQuery } from 'usehooks-ts';
import { Box } from '../Box';
import { Button } from '../Button';
import { Typography } from '../Typography';
import { StyledErrorPageRoot } from './ErrorPage.styled';
import type { ErrorPageProps } from './ErrorPage.types';

export const ErrorPage = ({ title, description, button, img }: ErrorPageProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoint.tablet}px)`);

  return (
    <StyledErrorPageRoot>
      {img && (
        <>
          <div className='error-page-img'>{img}</div>
          <Box height={24} />
        </>
      )}
      {title && (
        <>
          <Typography fontType={isMobile ? 'header2.bold' : 'title2.bold'}>{title}</Typography>
          <Box height={16} />
        </>
      )}
      {description && (
        <>
          <Typography
            css={{ whiteSpace: 'pre-wrap' }}
            fontType={isMobile ? 'body2.regular' : 'body.regular'}
            textAlign='center'
          >
            {description}
          </Typography>
          <Box height={24} />
        </>
      )}
      {button && (
        <Button size={isMobile ? 'M' : 'L'} variant='ghost.primary'>
          {button}
        </Button>
      )}
    </StyledErrorPageRoot>
  );
};
